import { createContext, use, type ReactNode } from 'react'

const PreviewContext = createContext(false)

/** Whether this page renders inside a TV preview, without a display session. */
export function useDisplayPreview(): boolean {
  return use(PreviewContext)
}

/** Scope rendering rules to a preview without changing the signed-in session. */
export function DisplayPreviewProvider({
  children
}: {
  children: ReactNode
}): ReactNode {
  return <PreviewContext value={true}>{children}</PreviewContext>
}
